export const TYPE_OF_TRANSFER = [
  { label: "Basic Life Support (BLS) ", value: "basicLifeSupport" },
  { label: "Advance Life Support (ALS)", value: "advanceLifeSupport" },
  { label: "Critical Care Transport (CCT)", value: "criticalCareTransport" },
  { label: "Other Vehicle", value: "otherVehicle" },
];

export const TYPE_OF_DEPARTMENT = [
  { label: "Emergency Care", value: "emergencyCare" },
  { label: "Observation Care", value: "observationCare" },
  { label: "Orthopedic Clinic", value: "orthopedicClinic" },
  { label: "Dental Clinic", value: "dentalClinic" },
  { label: "Vision Clinic", value: "visionClinic" },
];

export const TYPE_OF_TRANSFER_DISPOSITION_DATA = {
  PROPERTY: "property",
  TYPE_OF_TRANSFER: "typeOfTransfer",
  TRANSFER_FACILITY: "transferFacility",
  JAMBOREE_HEALTH_CENTER: "jamboreeHealthCenter",
  HOSPITAL: "hospital",
};

export const CLINIC_LOCATION_DROPDOWN_DATA = [
  { label: "Charlie Base Camp", value: "charlieBaseCamp" },
  { label: "Delta Base Camp", value: "deltaBaseCamp" },
  { label: "Echo Base Camp", value: "echoBaseCamp" },
];

export const TRANSFER_TO_CLINIC_LOCATION_DISPOSITION_DATA = {
  CLINIC_LOCATION: "basecamp",
};

export const HOSPITAL_NAME = [
  { label: "Beckley ARH Hospital", value: "Beckley ARH Hospital" },
  {
    label: "Charleston Area Medical Center",
    value: "Charleston Area Medical Center",
  },
  { label: "Carilion Clinic", value: "Carilion Clinic" },
  { label: "J.W. Ruby Memorial Hospital", value: "Carilion Clinic" },
  { label: "Other", value: "Other" },
];

export const CLEAR_EMS_FORM_DATA = {
  INJURY_TYPE: "injuryType",
  INJURY_LOCATION: "injuryLocation",
  WITNESS_NAME: "witnessName",
  INCIDENT_LOCATION: "incidentLocation",
};
